import React from 'react'
import { SVGIconProps } from '../types'
const SvgLoader = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 38 38"
    fill="currentColor"
    {...props}
  >
    <style>
      {
        '@keyframes rotating{0%{transform-origin:50% 50%;transform:rotate(0deg)}100%{transform-origin:50% 50%;transform:rotate(720deg)}}@keyframes fade{0%{opacity:1}50%{opacity:0.3}100%{opacity:1}}'
      }
    </style>
    <g fill="none" fillRule="evenodd">
      <circle cx={19} cy={19} r={19} />
      <path
        fill="#b5c8d4"
        d="M19 0c10.493 0 19 8.507 19 19h-3c0-8.837-7.163-16-16-16zM3 19c0 8.837 7.163 16 16 16v3C8.507 38 0 29.493 0 19z"
        style={{
          animation: 'rotating 1s infinite cubic-bezier(.61,-0.11,.32,1.13)',
        }}
      />
      <circle
        cx={19}
        cy={19}
        r={8}
        fill="#6f8a9b"
        style={{
          animation: 'fade 1s infinite',
        }}
      />
    </g>
  </svg>
)
export default SvgLoader
